import React from 'react';
import { DiscountCard } from './DiscountCard';
import { Discount } from '../../models/Discount';

const discountsListStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '32px',
  paddingBottom: '32px',
  maxWidth: '980px',
  margin: 'auto'
} as React.CSSProperties;

export interface DiscountCardsListProps {
  discounts: Discount[];
}

export const DiscountCardsList: React.FC<DiscountCardsListProps> = ({ discounts }) => {
  return (
    <div style={discountsListStyle}>
      {discounts.map((discount: Discount) => {
        return <DiscountCard key={discount._id} discount={discount} />;
      })}
    </div>
  );
};
